import { Grid, Typography } from '@mui/material';
import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';
import { FormikAppTextField } from 'components/formik/core/FormikAppTextField/FormikAppTextField';
import { useGuestContactHostMutation } from 'components/views/pages/contact/useGuestContactHostMutation';
import { IS_DIRECT_VACATIONS } from 'config/envSetup';
import { Formik, Form } from 'formik';
import { useRouter } from 'next/router';
import { ContactSteps } from 'pages/[propertyId]/contact';
import { getNumberOrZero } from 'helpers/numHelpers';

const initialValues = {
  message: '',
};

type ContactSendMessageFormikValues = typeof initialValues;

interface Props {
  guestId: number;
  propertyId: number;
  adults: string | undefined;
  pChildren: string | undefined;
  infants: string | undefined;
  pets: string | undefined;
  startDate: string | undefined;
  endDate: string | undefined;
}

export const ContactSendMessageForm = ({
  guestId,
  propertyId,
  adults,
  pChildren,
  infants,
  pets,
  startDate,
  endDate,
}: Props) => {
  const router = useRouter();
  const guestContactHostMutation = useGuestContactHostMutation();

  const onSubmit = (values: ContactSendMessageFormikValues) => {
    guestContactHostMutation.mutate(
      {
        message: values.message,
        id: guestId,
        property_id: propertyId,
        is_direct_vacations: IS_DIRECT_VACATIONS(),
        adults: adults !== undefined ? getNumberOrZero(adults) : 1,
        children: getNumberOrZero(pChildren),
        infants: getNumberOrZero(infants),
        pets: getNumberOrZero(pets),
        arrival: startDate,
        departure: endDate,
      },
      {
        onSuccess: () => {
          router.query.step = ContactSteps.MessageSent.toString();
          router.push(router);
        },
      },
    );
  };

  return (
    <Grid item xs={12}>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">What is Your Message to the Host?</Typography>
            </Grid>
            <Grid item xs={12}>
              <FormikAppTextField
                id={'message'}
                name="message"
                multiline
                fullWidth
                placeholder="Write your message"
                label="Message to the host"
                minRows={5}
                maxRows={100}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <LoadingButton
                isLoading={guestContactHostMutation.isLoading}
                isFullWidth
                isFormikButton
                text="Send Message"
                size="large"
              />
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Grid>
  );
};
